module.exports = "/_next/static/media/new-search-color-wheel.55a8787c.png";